import { SearchInput } from '@borg/pim-components'
import React, { useState, type FunctionComponent, type ReactNode } from 'react'
import { Pill } from '../'
import {
	BottomWrapper,
	FiltersWrapper,
	FilterButtonsWrapper,
	PillWrapper,
	TopWrapper,
	ActionsWrapper,
} from './integrations-filters.styles'

type PillProperties = {
	label: string,
	count?: number,
	selected?: boolean,
}

type AvailableIntegrationsFiltersProps = {
	onSearchChange: ( value: string | null ) => void,
	onSearchStart?: () => void,
	onPillClick?: ( label: string ) => void,
	filters?: ReactNode,
	learn?: ReactNode,
	sort?: ReactNode,
	pills?: PillProperties[],
}

export const IntegrationsFilters: FunctionComponent<AvailableIntegrationsFiltersProps> = ( {
	onSearchChange,
	onSearchStart,
	filters = null,
	learn = null,
	sort = null,
	pills = [],
	onPillClick,
} ) => {
	const [ isReadyToFireSearchStart, setIsReadyToFireSearchStart ] = useState( true )
	const [ searchValue, setSearchValue ] = useState<string | null>( null )

	return (
		<FiltersWrapper>
			<TopWrapper>
				<SearchInput
					autoApply
					onFocus={() => {
						setIsReadyToFireSearchStart( true )
					}}
					onChange={( value: string | null ) => {
						if ( searchValue !== value ) {
							onSearchChange( value )
							setSearchValue( value )

							if ( isReadyToFireSearchStart && onSearchStart && value ) {
								onSearchStart()
								setIsReadyToFireSearchStart( false )
							}
						}
					}}
					onClear={() => onSearchChange( null )}
				/>
				<FilterButtonsWrapper>
					{ filters }
				</FilterButtonsWrapper>
			</TopWrapper>
			<BottomWrapper>
				<PillWrapper>
					{pills.map( ( { label, count, selected } ) => (
						<Pill
							key={label}
							label={label}
							count={count}
							selected={selected}
							onClick={onPillClick}
						/>
					) )}
				</PillWrapper>
				{( learn || sort ) && (
					<ActionsWrapper>
						{learn}
						{sort}
					</ActionsWrapper>
				)}
			</BottomWrapper>
		</FiltersWrapper>
	)
}
